import type { FC } from 'react';
import { Box, Flex } from '@eqi-investimentos/react';
import {
  ContentMode,
  ContentModeEnum,
  type Content,
} from '@/modules/Content/interface/Content';
import { IfRender } from '@/utils/jsx';

export const ContentScreenLive: FC<ContentScreenLiveProps> = ({
  content,
  contentMode,
}) => {
  return (
    <IfRender
      condition={contentMode === ContentModeEnum.VIDEO && !!content.live_embed}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        w="full"
        bgColor="background.alwaysDark"
      >
        <Flex w="full" maxH="32.5rem" overflow="hidden">
          {content.live_embed && (
            <Box
              as="iframe"
              title={`iframe-${content.id}`}
              src={content.live_embed}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              w="full"
              aspectRatio={16 / 9}
            />
          )}
        </Flex>
      </Flex>
    </IfRender>
  );
};

type ContentScreenLiveProps = {
  content: Content;
  contentMode: ContentMode;
};
